/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { Observable, of } from 'rxjs';
import { switchMap, mergeMap, catchError } from 'rxjs/operators';
import { ofType, StateObservable } from 'redux-observable';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { Action, ActionCreators } from './actions';
import { RootState } from '../index';
import { ActionCreators as MapActionCreators } from '../maps/actions';
import { handleErrorInterceptor } from '../../utils/AuthUtils';
import { GOOGLE_MAP_INSTANCE_KEY } from '../../components/common/map/GoogleMapSingleton';

const requestBeamsSuccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedBeamsSuccess.create(response);
};

const requestBeamsError = (error: AjaxError): any => {
  return ActionCreators.ReceivedBeamsError.create(error);
};

const requestFlHeatMapsSucccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedFlHeatMapsSuccess.create(response);
};

const requestFlHeatMapsError = (error: AjaxError): any => {
  return ActionCreators.ReceivedFlHeatMapsError.create(error);
};

const requestRlHeatMapsSucccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedRlHeatMapsSuccess.create(response);
};

const requestRlHeatMapsError = (error: AjaxError): any => {
  return ActionCreators.ReceivedRlHeatMapsError.create(error);
};

const updateCurrentOverlaysContext = (response: AjaxResponse<any>, mapId = GOOGLE_MAP_INSTANCE_KEY): any => {
  return MapActionCreators.UpdateCurrentOverlaysContext.create({ geojson: response, mapId });
};

export const requestBeamsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestBeams.type),
    switchMap(
      ($action: any): Observable<Action> =>
        ajaxRaw.post('/map/contours', $action.payload).pipe(
          mergeMap((response: AjaxResponse<any>): Action[] => [
            requestBeamsSuccess(response),
            updateCurrentOverlaysContext(response),
          ]),
          catchError(
            (error: AjaxError): Observable<Action> =>
              handleErrorInterceptor(
                error,
                of(requestBeamsError(error))
              ),
          ),
        ),
    ),
  );

export const requestFlHeatMapsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestFlHeatMaps.type),
    switchMap(
      ($action: any): Observable<Action> =>
        ajaxRaw.get(`/map/heatmap/flcontour/${$action.payload.sscfFileVersion}/${$action.payload.antennaTypeId}`).pipe(
          mergeMap((response: AjaxResponse<any>): Action[] => [requestFlHeatMapsSucccess(response)]),
          catchError(
            (error: AjaxError): Observable<Action> =>
              handleErrorInterceptor(
                error,
                of(requestFlHeatMapsError(error))
              ),
          ),
        ),
    ),
  );
  
export const requestRlHeatMapsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestRlHeatMaps.type),
    switchMap(
      ($action: any): Observable<Action> =>
        ajaxRaw.get(`/map/heatmap/rlcontour/${$action.payload.sscfFileVersion}/${$action.payload.antennaTypeId}`).pipe(
          mergeMap((response: AjaxResponse<any>): Action[] => [requestRlHeatMapsSucccess(response)]),
          catchError(
            (error: AjaxError): Observable<Action> =>
              handleErrorInterceptor(
                error,
                of(requestRlHeatMapsError(error))
              ),
          ),
        ),
    ),
  );
